/**
 * Recipient caps for an internal email.
 *
 * The API serves these on the composer's prefill (`recipient_limits`), which is what the
 * picker reads; these are the fallback for a payload that predates that field, and the
 * numbers the refusal message names.
 *
 * Mirrors `Ats::InternalEmails::Creator` — core `app/lib/ats/internal_emails/creator.rb`.
 * The backend stays the authority: it resolves roles to people, dedupes them, and
 * subtracts To from cc/bcc before counting, none of which the client can do. A send past
 * the cap is still refused with `err_internal_email_too_many_recipients`.
 *
 * They are two budgets rather than one because the halves cost different things. Every
 * person in To gets their own message, their own job and their own delivery — that is
 * what lets a teammate reply without the others seeing — so To is bounded by how long a
 * send takes and how much of the sender's daily allowance it spends. Everyone on cc and
 * bcc shares the single primary copy, so that number is the providers': the Gmail API
 * and Exchange Online both refuse one message addressed to more than 500.
 */
export const MAX_TO_RECIPIENTS = 200;

export const MAX_CC_BCC_RECIPIENTS = 450;

/** `Creator::MAX_RECIPIENTS` — the largest a single send can be. */
export const MAX_INTERNAL_EMAIL_RECIPIENTS =
  MAX_TO_RECIPIENTS + MAX_CC_BCC_RECIPIENTS;
